import React from "react";
import EventItem from "./EventItem";
import SimpleTable from "../../ui/Table/SimpleTable";

const columns = [
  { accessor: "datetime", title: "Дата" },
  {
    accessor: "uid",
    title: "Пользователь (ID)",
    className: "table__border-right"
  },
  { _key: "action", title: "Действия", className: "table__border-right" },
  {
    _key: "title",
    title: "Заголовок анонса",
    className: "table__border-right"
  },
  { accessor: "tid", title: "Анонс ID" },
  { accessor: "fields_count", title: "Поле" }
];

const ChangeLogTable = ({
  loading,
  items,
  onSortChange,
  sortBy,
  sortOrder
}) => {
  return (
    <SimpleTable
      columns={columns}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSortChange={onSortChange}
      loading={loading}
    >
      {items.map(event => (
        <EventItem event={event} key={event.event_id} />
      ))}
    </SimpleTable>
  );
};

export default ChangeLogTable;
